export class FolderTemplateModel{
  id: number;
  name: string;
}
